export const ADMIN_TOKEN_KEY = 'admin-token';
export const ADMIN_REFRESH_TOKEN_KEY = 'admin-refresh-token';
export const REDIRECT_URL_KEY = 'redirect-url';

export const CUSTOMER_PENDING_KEY = 'PENDING';
export const CUSTOMER_CHECKED_KEY = 'CHECKED';
export const CUSTOMER_REQUESTED_KEY = 'REQUESTED';
export const CUSTOMER_CONFIRMED_KEY = 'CONFIRMED';
export const CUSTOMER_BLACK_LISTED_KEY = 'BLACK_LISTED';
export const CUSTOMER_CONTRACTED_KEY = 'CONTRACTED';
export const CUSTOMER_APPROVED_KEY = 'APPROVED';
